// @react/hooks/useAffiliateConversion.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { affiliateConversionStore } from '@core/stores';

/**
 * React hook for Conversion operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useAffiliateConversion } from '@react/hooks';
 *
 * const ConversionList = observer(() => {
 *   const store = useAffiliateConversion();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useAffiliateConversion() {
  return affiliateConversionStore;
}
